import { render, staticRenderFns } from "./FileListItemDetail.vue?vue&type=template&id=147cc2c0&"
import script from "./FileListItemDetail.vue?vue&type=script&lang=js&"
export * from "./FileListItemDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports